import { render, staticRenderFns } from "./memberShipCenter.vue?vue&type=template&id=6b1a75ee&scoped=true"
import script from "./memberShipCenter.vue?vue&type=script&lang=js"
export * from "./memberShipCenter.vue?vue&type=script&lang=js"
import style0 from "./memberShipCenter.vue?vue&type=style&index=0&id=6b1a75ee&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1a75ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b1a75ee')) {
      api.createRecord('6b1a75ee', component.options)
    } else {
      api.reload('6b1a75ee', component.options)
    }
    module.hot.accept("./memberShipCenter.vue?vue&type=template&id=6b1a75ee&scoped=true", function () {
      api.rerender('6b1a75ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/config/memberShipCenter.vue"
export default component.exports